import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { KlLoadingService } from "app/modules/shared/services/kl-loading.service";
import { UserLoginView } from "app/data/authentication/models/user-login-view";
import { AuthService } from "app/modules/shared/services/auth.service";
import { UserService } from "app/modules/shared/services/user.service";
import { UtilService } from "app/modules/shared/services/util.service";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";

@Component({
  selector: "kl-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  user: UserLoginView = new UserLoginView();
  errorStatus = false;
  alertShow = false;
  errorMessage: string;
  selectedLanguage: string;

  constructor(
    private auth: AuthService,
    private router: Router,
    private userService: UserService,
    private _translate: TranslateService,
    private klLoadingService: KlLoadingService,
    private utilService: UtilService
  ) {}

  ngOnInit() {
    if (localStorage.getItem("currentLanguage")) {
      this.selectedLanguage = localStorage.getItem("currentLanguage");
    } else {
      this.selectedLanguage = "tr";
    }
    if (!localStorage.getItem("local_currency")) {
      localStorage.setItem("local_currency", "1");
    }
    if (sessionStorage.getItem("currentLanguage")) {
      this.selectedLanguage = sessionStorage.getItem("currentLanguage");
    } else {
      this.selectedLanguage = "tr";
    }
    if (!sessionStorage.getItem("local_currency")) {
      sessionStorage.setItem("local_currency", "1");
    }
    this.selectLang(this.selectedLanguage);
  }

  selectLang(language: string) {
    this._translate.useCulture(language);
    this._translate.use(language);
    document.getElementsByTagName("html")[0].setAttribute("lang", language);
    if (
      language !== "fa" &&
      document.getElementsByTagName("html")[0].hasAttribute("dir")
    ) {
      document.getElementsByTagName("html")[0].removeAttribute("dir");
    } else if (
      language === "fa" &&
      !document.getElementsByTagName("html")[0].hasAttribute("dir")
    ) {
      document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
    }
  }

  onSubmit() {
    this.klLoadingService.show("loading");
    this.user.grant_type = "password";
    this.auth.login(this.user).subscribe(
      (loginResponse) => {
        if (loginResponse === undefined) {
          this.errorMessage = this.utilService.alertErrorMessage("error_data");
          this.errorStatus = true;
          this.klLoadingService.hide();
        } else {
          this.klLoadingService.hide();
          UtilService.saveLocalStorage({ token_date: new Date().getTime() });
          UtilService.saveLocalStorage(loginResponse);
          this.errorStatus = false;
          return this.router.navigateByUrl("/dashboard");
        }
      },
      (error) => {
        this.errorMessage = this.utilService.alertErrorMessage(error);
        this.errorStatus = true;
        this.klLoadingService.hide();
      }
    );
  }
}
